import React, { useState, useEffect, useRef, useContext } from 'react';
import User from '../components/Utils';
import FindLocationHome from '../components/FindLocationHome';
import LoaderContext from '../components/LoaderContext';
import MenuBar from '../components/Menubar';
import { Link } from 'react-router-dom';

type Props = {
  user: User;
  handleLogin(user: User): void;
};

const AdminEmailExportPage: React.FC<Props> = (props) => {
  const [city, setCity] = useState('');
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 });
  const [emails, setEmails] = useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [disable, isDisable] = useState(true);


  const findNearByUserEmails = async (lat, lng) => {
    try {
      showLoader();
      // console.log(latLng.lat.toString() +" "+ latLng.lng.toString());
      const url = new URL(`${process.env.REACT_APP_SERVER_URL}/users-nearby`);
      url.searchParams.append('latitude', lat);
      url.searchParams.append('longitude', lng);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${props.user.token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setEmails(data || []);
        hideLoader();
      } else {
        throw new Error('Failed to fetch emails');
      }
    } catch (err) {
      console.error('Failed to save location:', err);
      hideLoader();
      setEmails([]);
    }
  };

  const handlePlaceChange = async (place: google.maps.places.PlaceResult) => {
    isDisable(false);
    if (place.geometry?.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      console.log(lat + " " + lng + "before")
      setLatLng({ lat, lng })
      console.log(lat + " " + lng + " after");
      await findNearByUserEmails(lat, lng);

      // Extract city name if you still want it
      if (place.address_components) {
        const cityComponent = place.address_components.find(component =>
          component.types.includes('locality')
        );
        setCity(cityComponent?.long_name || '');
      }
    } else {
      setLatLng({ lat: 0, lng: 0 });
      setCity('');
    }
  };
  // Setup Google Autocomplete
  useEffect(() => {
    if (!inputRef.current || !window.google) return;

    const options = {
      types: ['(cities)'],
    };

    const autocomplete = new google.maps.places.Autocomplete(inputRef.current, options);

    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();
      handlePlaceChange(place);
    });

    return () => {
      google.maps.event.clearInstanceListeners(autocomplete);
    };
  }, [handlePlaceChange]);

  const handleDownloadCSV = () => {
    showLoader();
    // if (emails.length === 0){
    //   hideLoader();
    //   return;
    // }

    const csv = ['Email'].concat(emails).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${city || 'emails'}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    hideLoader();
  };

  if (!props.user.isLogged || (props.user.id !== 6 && props.user.id !== 7 && props.user.id !== 514)) {
    return (
      <div>
        <div>Access denied.</div>
      </div>
    )
  } else {
    return (
      <main className="main-bg">
        <div className="container">
          <MenuBar user={props.user} />
          <div className="small-container add-yolo-info text-center">
            <div
              className="start-row d-flex full-height align-items-center"
              style={{ flexDirection: 'column', paddingTop: '20px' }}
            >
              <h2 className="futuralt-book mt-4 pt-2 mb-4">Email Export Panel</h2>

              <input
                ref={inputRef}
                className="field md-filed text-center"
                type="text"
                placeholder="Search and select a location"
              />

              <input
                type="button"
                className="btn-primary mt-3 mb-3"
                value="Download CSV"
                onClick={handleDownloadCSV}
                disabled={disable}
                style={{
                  backgroundColor: disable ? '#ccc' : '',
                  color: disable ? '#666' : '',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
              />

              <h3 className="futuralt-book mb-2">
                Emails for selected location
              </h3>

              <div
                style={{
                  maxHeight: '300px',
                  width: '100%',
                  overflowY: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  padding: '10px',
                  backgroundColor: 'white',
                }}
              >
                {emails.length > 0 ? (
                  <ul style={{ listStyle: 'none', padding: 0 }}>
                    {emails.map((email, index) => (
                      <li key={index} style={{ marginBottom: '8px', fontSize: '16px' }}>
                        {email}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No emails found for this city.</p>
                )}
              </div>
              <button
                className={'see-restaurant-button black font-bold'}
                style={{marginTop:'180px', marginLeft:'-830px'}}
              >
                <Link to="/admin">Back</Link>
              </button>
            </div>
          </div>
        </div>
      </main>
    );
  }
};

export default AdminEmailExportPage;
